import Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default () => {
  var quill = new Quill('#js-quill-editor', {
    theme: 'snow',
  });

  const formElement = document.querySelector('#js-form');
  const savedDescriptionElement = document.querySelector('#description');
  const savedDescription = savedDescriptionElement.value;

  quill.pasteHTML(savedDescription);
  formElement.addEventListener('submit', () => {
    savedDescriptionElement.value = quill.container.firstChild.innerHTML;
  });

  const $thumbInput = $('#thumb_input');
  $thumbInput.on('change', (e) => {
    const file = e.target.files[0];
    const fd = new FormData();
    fd.append('image', file);
    $('.upload-notification').addClass('uploading');

    $.post({
      url: '/api/image/upload',
      type: 'POST',
      data: fd,
      processData: false,
      contentType: false,
    }).then((response) => {
      $('#thumb_input_hidden').val(response.public_id);
      $('#image_preview').attr('src', response.url);
      $('.upload-notification').removeClass('uploading');
      $('.upload-notification').addClass('uploaded');

      setTimeout(() => {
        $('#upload-notification').removeClass('uploaded');
      }, 3000);
    });
  });
};
